export default {
  menu: {
    Home: {
      Title: "Home",
    },
    Search: "Search",
    Versions: "Versions",
    Api: {
      Title: "Develop Guideline",
      Api: "How to use HiTRUSTpay RESTful API",
    },
    Auth: {
      Title: "Authorization API",
      Auth: "Credit Card Authorization",
      TrxtokenAuth: "Credit Card Authorization with Trxtoken",
      BindingCardAuth: "Credit Card Card Binding Authorization",
      AuthSSL: "Credit Card Authorization SSL",
      TrxtokenAuthSSL: "Credit Card Authorization SSL with Trxtoken",
      MobileAuth: "Mobile Payment Encrypted Data Authorization",
      MobileAuthDecrypted: "Mobile Payment Decrypted Data Authorization",
      AfteeAuth: "AFTEE Authorization",
      LinepayAuth: "LINE Pay Authorization",
      IpassAuth: "iPASS Authorization",
      CfcAuth: "Zingala Installment Authorization",
      EzwAuth: "Easy Wallet Authorization",
      JkoAuth: "JKO Authorization",
      PxPayAuth: "PXPay Authorization",
      UpopAuth: "UPOP Authorization",
      FollowPay: "Follow Pay Authorization",
      Jpay: "J-PAY Authorization",
    },
    Query: {
      Title: "Query API",
      QueryOrder: "Credit Card Order Query",
      QueryFunbizOrder: "Funbiz Order Query",
      QueryUpopOrder: "UPOP Order Query",
      AfteeQuery: "AFTEE Order Query",
      CfcQueryOrder: "Zingala Installment Order Query",
      EzwQueryOrder: "Easy Wallet Order Query",
      IpassQueryOrder: "iPASS Order Query",
      JkoQueryOrder: "JKO Order Query",
      LinepayQueryOrder: "LINE Pay Order Query",
      PxPayQueryOrder: "PXPay Order Query",
      JpayQueryOrder: "J-PAY Order Query",
    },
    Transaction: {
      Title: "Transaction Management API",
      AuthReverse: "Authorization Reversal",
      Capture: "Capture",
      CaptureReverse: "Capture Reversal",
      Refund: "Refund",
      RefundReverse: "Refund Reversal",
      UpopAuthReverse: "UPOP Authorization Reversal",
      UpopCapture: "UPOP Capture",
      UpopCaptureReverse: "UPOP Capture Reversal",
      UpopRefund: "UPOP Refund",
      UpopRefundReverse: "UPOP Refund Reversal",
      CardholderVerify: "Phone Number Verification",
    },
    AP: {
      Title: "Virtual Account API",
      VirtualAccountPayment: "Virtual Account Payment",
      VirtualAccountQuery: "Virtual Account Order Query",
      SpbVirtualAccountRefund: "SPB Virtual Account Refund",
    },
    Cvs: {
      Title: "CVS (Convenience Store) API",
      CvsPayment: "CVS Payment",
      CvsQuery: "CVS Order Query",
    },
    Easypay: {
      Title: "Easypay API",
      EasypayCreate: "Easypay Creation",
      EasypayQuery: "Easypay Order Query",
      EasypayUpdate: "Easypay Order Status Update",
    },
    RecurringPayment: {
      Title: "Recurring Payment API",
      CancelRecurringPayment: "Cancel Recurring Payment Order",
      ResendRecurringPayment: "Resend Recurring Payment Order",
      QueryRecurringPayment: "Recurring Payment Order Query",
    },
    VeriId: {
      Title: "Veri-Id Service",
      VeriIdReviewOrder: "Veri-Id Order Review",
      VeriIdQueryRiskTransactionData: "Veri-Id Risk Detection Query",
    },
    References: {
      Title: "Transaction Reference Information",
      Retcode: "Response Message List (retcode)",
      TestCardData: "Test Card Information. ",
      OrderStatus: "Order Status Code",
    },
    Versions: "Versions",
    Param: {
      Title: "Parameter",
      AuthRequest: "Credit Card Authorization Request JSON Object",
      AuthResponse: "Credit Card Authorization Response JSON Object",
      ReturnUrlQuery: "Specified redirect URL returnURL Query Parameter",
      UpdateAuthRequest: "Credit Card Authorization Result JSON Object",
      ApiReponseError:
        "If the request fails HiTRUSTpay's verification, an Error Response Model will be returned as shown below.",
      ApiReponseModel:
        "HiTRUSTpay API response according to the specification. The API Response Model format is as follows.",
      TrxtokenAuthRequest: "Authorization with Trxtoken Request JSON Object",
      TrxtokenAuthResponse: "Authorization with Trxtoken Response JSON Object",
      UpdateTrxtokenAuthRequest:
        "Authorization with Trxtoken Result JSON Object",
      BindingCardAuthRequest:
        "Credit Card Card Binding Authorization Request JSON Object",
      BindingCardAuthResponse:
        "Credit Card Card Binding Authorization Response JSON Object ",
      UpdateBindingCardAuthRequest:
        "Credit Card Card Binding Authorization Result Request JSON Object",
      AuthSSLRequest: "Credit Card Authorization SSL Request JSON Object",
      AuthSSLResponse: "Credit Card Authorization SSL Response JSON Object",
      UpdateAuthSSLRequest:
        "Credit Card Authorization SSL Result Request JSON Object",
      TrxtokenAuthSSLRequest:
        "Credit Card Authorization SSL with Trxtoken Request JSON Object",
      TrxtokenAuthSSLResponse:
        "Credit Card Authorization SSL with Trxtoken Response JSON Object",
      UpdateTrxtokenAuthSSLRequest:
        "Credit Card Authorization SSL with Trxtoken Result Request JSON Object ",
      MobileAuthRequest:
        "Mobile Payment Encrypted Data Authorization Request JSON Object",
      MobileAuthResponse:
        "Mobile Payment Encrypted Data Authorization Response JSON Object",
      UpdateMobileAuthRequest:
        "Mobile Payment Encrypted Data Authorization Result Request JSON Object",
      MobileAuthDecryptedRequest:
        "Mobile Payment Decrypted Data Authorization Request JSON Object",
      MobileAuthDecryptedResponse:
        "Mobile Payment Decrypted Data Authorization Response JSON Object ",
      UpdateMobileAuthDecryptedRequest:
        "Mobile Payment Decrypted Data Authorization Result Request JSON Object",
      AfteeAuthRequest: "AFTEE Authorization Request JSON Object",
      AfteeAuthResponse: "AFTEE Authorization Response JSON Object",
      UpdateAfteeAuthRequest: "AFTEE Authorization Result Request JSON Object",
      LinepayAuthRequest: "LINE Pay Authorization Request JSON Object",
      LinepayAuthResponse: "LINE Pay Authorization Response JSON Object",
      UpdateLinepayAuthRequest:
        "LINE Pay Authorization  Result Request JSON Object",
      IpassAuthRequest: "iPASS Authorization Request JSON Object",
      IpassAuthResponse: "iPASS Authorization Response JSON Object",
      UpdateIpassAuthRequest: "iPASS Authorization Result Request JSON Object",
      CfcAuthRequest: "Zingala Installment Authorization Request JSON Object",
      CfcAuthResponse: "Zingala Installment Authorization Response JSON Object",
      UpdateCfcAuthRequest:
        "Zingala Installment Authorization Result Request JSON Object",
      EzwAuthRequest: "Easy Wallet Authorization Request JSON Object",
      EzwAuthResponse: "Easy Wallet Authorization Response JSON Object",
      UpdateEzwAuthRequest:
        "Easy Wallet Authorization Result Request JSON Object",
      JkoAuthRequest: "JKO Authorization Request JSON Object",
      JkoAuthResponse: "JKO Authorization Response JSON Object",
      UpdateJkoAuthRequest: "JKO Authorization Result Request JSON Object",
      PxPayAuthRequest: "PXPay Authorization Request JSON Object",
      PxPayAuthResponse: "PXPay Authorization Response JSON Object",
      UpdatePxPayAuthRequest: "PXPay Authorization Result Request JSON Object",
      UpopAuthRequest: "UPOP Authorization Request JSON Object",
      UpopAuthResponse: "UPOP Authorization Response JSON Object ",
      UpdateUpopAuthRequest: "UPOP Authorization Result Request JSON Object",
      JpayAuthRequest: "J-PAY Authorization Request JSON Object",
      JpayAuthResponse: "J-PAY Authorization Response JSON Object",
      UpdateJpayAuthRequest: "J-PAY Authorization Result Request JSON Object",
      JpayQueryOrderRequest: "J-PAY Order Query Request JSON Object",
      JpayQueryOrderResponse: "J-PAY Order Query Response JSON Object",
      AfteeQueryRequest: "AFTEE Order Query Request JSON Object",
      AfteeQueryResponse: "AFTEE Order Query Response JSON Object",
      LinepayQueryRequest: "LINE Pay Order Query Request JSON Object",
      LinepayQueryResponse: "LINE Pay Order Query Response JSON Object",
      JkoQueryRequest: "JKO Order Query Request JSON Object",
      JkoQueryResponse: "JKO Order Query Response JSON Object",
      PxPayQueryRequest: "PXPay Order Query Request JSON Object",
      PxPayQueryResponse: "PXPay Order Query Response JSON Object",
      UpopQueryRequest: "UPOP Order Query Request JSON Object",
      UpopQueryResponse: "UPOP Order Query Response JSON Object",
      IpassQueryRequest: "iPASS Order Query Request JSON Object",
      IpassQueryResponse: "iPASS Order Query Response JSON Object",
      EzwQueryRequest: "Easy Wallet Order Query Request JSON Object",
      EzwQueryResponse: "Easy Wallet Order Query Response JSON Object",
      CfcQueryRequest: "Zingala Installment Order Query Request JSON Object",
      CfcQueryResponse: "Zingala Installment Order Query Response JSON Object",
      QueryOrderRequest: "Credit Card Order Query Request JSON Object",
      QueryOrderResponse: "Credit Card Order Query Response JSON Object",
      QueryFunbizOrderRequest: "Funbiz Order Query Request JSON Object",
      QueryFunbizOrderResponse: "Funbiz Order Query Response JSON Object",
      AuthReverseRequest: "Authorization Reversal Request JSON Object",
      AuthReverseResponse: "Authorization Reversal Response JSON Object",
      CaptureRequest: "Capture Request JSON Object",
      CaptureResponse: "Capture Response JSON Object ",
      CaptureReverseRequest: "Capture Reversal Request JSON Object",
      CaptureReverseResponse: "Capture Reversal Response JSON Object",
      RefundRequest: "Refund Request JSON Object",
      RefundResponse: "Refund Response JSON Object",
      RefundReverseRequest: "Refund Reversal Request JSON Object",
      RefundReverseResponse: "Refund Reversal Response JSON Object",
      UpopAuthReverseRequest: "UPOP Authorization Reversal Request JSON Object",
      UpopAuthReverseResponse:
        "UPOP Authorization Reversal Response JSON Object",
      UpopCaptureRequest: "UPOP Capture Request JSON Object",
      UpopCaptureResponse: "UPOP Capture Response JSON Object",
      UpopCaptureReverseRequest: "UPOP Capture Reversal Request JSON Object",
      UpopCaptureReverseResponse: "UPOP Capture Reversal Response JSON Object",
      UpopRefundRequest: "UPOP Refund Request JSON Object",
      UpopRefundResponse: "UPOP Refund Response JSON Object",
      UpopRefundReverseRequest: "UPOP Refund Reversal Request JSON Object",
      UpopRefundReverseResponse: "UPOP Refund Reversal Response JSON Object",
      CardholderVerifyRequest: "Phone Number Verification Request JSON Object",
      CardholderVerifyResponse:
        "Phone Number Verification Response JSON Object",
      VirtualAccountPaymentRequest:
        "Virtual Account Payment Request JSON Object",
      VirtualAccountPaymentResponse:
        "Virtual Account Payment Response JSON Object",
      UpdateVirtualAccountPaymentRequest:
        "Virtual Account Order Created Notification Request JSON Object",
      VirtualAccountQueryRequest:
        "Virtual Account Order Query Request JSON Object",
      VirtualAccountQueryResponse:
        "Virtual Account Order Query Response JSON Object",
      SpbVirtualAccountRefundRequest:
        "SPB Virtual Account Refund Request JSON Object",
      SpbVirtualAccountRefundResponse:
        "SPB Virtual Account Refund Response JSON Object",
      UpdateVirtualAccountSettlementRequest:
        "Virtual Account Reconciliation Result Request JSON Object",
      CvsPaymentRequest: "CVS Payment Request JSON Object",
      CvsPaymentResponse: "CVS Payment Response JSON Object",
      UpdateCvsPaymentRequest:
        "CVS Order Created Notification Request JSON Object",
      CvsQueryRequest: "CVS Order Query Request JSON Object",
      CvsQueryResponse: "CVS Order Query Response JSON Object",
      UpdateCvsSettlementRequest:
        "CVS Payment Reconciliation Result Request JSON Object",
      EasypayCreateRequest: "Easypay Creation Request JSON Object",
      EasypayCreateResponse: "Easypay Creation Response JSON Object",
      EasypayQueryRequest: "Easypay Order Query Request JSON Object",
      EasypayQueryResponse: "Easypay Order Query Response JSON Object",
      EasypayUpdateRequest: "Easypay Order Status Update Request JSON Object",
      EasypayUpdateResponse: "Easypay Order Status Update Response JSON Object",
      CancelRecurringPaymentRequest:
        "Cancel Recurring Payment Order Request JSON Object",
      CancelRecurringPaymentResponse:
        "Cancel Recurring Payment Order Response JSON Object",
      ResendRecurringPaymentRequest:
        "Resend Recurring Payment Order Request JSON Object",
      ResendRecurringPaymentResponse:
        "Resend Recurring Payment Order Response JSON Object",
      QueryRecurringPaymentRequest:
        "Recurring Payment Order Query Request JSON Object",
      QueryRecurringPaymentResponse:
        "Recurring Payment Order Query Response JSON Object",
      VeriIdReviewOrderRequest: "Veri-Id Order Review Request JSON Object",
      VeriIdReviewOrderResponse: "Veri-Id Order Review Response JSON Object",
      VeriIdQueryRiskTransactionDataRequest:
        "Veri-Id Risk Detection Query Request JSON Object",
      VeriIdQueryRiskTransactionDataResponse:
        "Veri-Id Risk Detection Query Response JSON Object",
      AuthUpdateParamPs:
        '<ol class=\'bullet-list\'><li>If the merchant receives the result successfully, please respond with JSON in the following format: &#123;"code": "0000", "message": "ok", "success": true&#125;</li><li>If the merchant fails to receive the result, please respond with JSON in the following format: &#123;"code": "1111", "message": "error", "success": false&#125;</li></ol>',
    },
  },
  table: {
    Header: {
      level: "Level",
      JSONAttributeName: "Json attribute Name",
      type: "Type",
      required: "Mandatory",
      description: "Description",
    },
    Body: {
      data: "<b>Response data</b>",
      code: "<b>Response code</b><br>#Response Message List (retcode)",
      code_simple: "<b>Response code</b>",
      message: "<b>Response message</b>",
      success: "<b>Request success status</b>",
      errorMessage: "<b>Error message</b>",
      resFalse: "<b>Returns false</b>",
      code_is0000: "<b>Returns 0000 if successful</b>",
      errorCode: "<b>Error code other than 0000</b>",
      api_jsonObj: "<b>API Specification Response JSON Object.</b>",
      emptyString: "<b>Empty String</b>",
      resTrue: "<b>Returns true</b>",
      merid: "<b>Merchant ID</b>",
      transType_simple: "<b>Transaction type</b>",
      orderNumber_simple: "<b>Order number</b>",
      orderNumber_19:
        "<b>Order number</b><br>Length: less than 19 characters; alphanumeric characters only.",
      orderNumber_20:
        "<b>Order number</b><br>Length: less than 20 characters; alphanumeric characters only.",
      orderNumber_19_recurring:
        "<b>First period order number</b><br>Length: less than 19 characters; alphanumeric characters only.",
      currency:
        "<b>Currency</b><br>The currency configured by the merchant during application<br>(in accordance with ISO 4217 standards).",
      amount:
        "<b>Transaction amount</b><br>It must include two decimal digits. e.g. If the input amount is 100, it means the “amount” is 1 dollar.",
      orderDesc: "<b>Order description</b><br>Length: less than 20 characters",
      easypayOrderDesc:
        "<b>Order description</b><br>Length: less than 20 Chinese  or 40 English characters",
      depositFlag:
        "<b>Capture mode</b><br>0 : Standard Transaction<br>1 : Sale Transaction(Auto deposit)",
      queryFlag:
        "<b>Query flag</b><br>0: General data.<br>1: HiTRUSTPay server will send the transaction detail to updateURL by the POST method",
      transactionQueryFlag:
        "<b>Query flag</b><br>0: General data.<br>1: HiTRUSTPay server will send the transaction detail to updateURL by the POST method",
      returnURL:
        "<b>Specified redirect URL.</b><br>The URL specified by the merchant for showing transaction results to the customer.",
      updateURL:
        "<b>Result callback URL</b><br>The URL which HiTRUSTpay notifies the merchant of the transaction result. If no URL is configured, no proactive notification will be sent.",
      apUpdateURL: "<b>Result callback URL</b>",
      pan: "<b>Credit card number</b>",
      expiry: "<b>Expiry date</b><br>Format: YYMM",
      cvv2: "<b>CVC2/CVV2</b><br>Security code: If the merchant has applied to enable CVC2/CVV2 verification, this field must contain the last three digits of the card's security code.",
      creditCard: "<b>Credit card information</b>",
      installmentPeriod: "<b>Installment period</b>",
      redeemFlag:
        "<b>Reward point flag</b><br>0: Disabled<br>1: Enabled<br>*The reward points feature cannot be used together with the installment payment feature.",
      idNumber:
        "<b>Cardholder's ID number</b><br>Start with an uppercase English letter, followed by 9 digits.",
      cellPhoneNumber:
        "<b>Cardholder cellphone number</b><br>Length is limited to 15 characters. This field is optional, it must be used together with the cardholder's ID number for verification.",
      birthYear:
        "<b>Cardholder year of birth</b><br>Format: yyyy. This field is optional, it must be used together with the cardholder's ID number and date of birth for verification.",
      birthDate:
        "<b>Cardholder date of birth</b><br>MMdd, optional<br>Verification must be combined with the cardholder's ID number",
      homePhoneNumber:
        "<b>Cardholder home phone number</b><br>Optional, length is limited to 15 characters. Verification must be combined with the cardholder's ID number. (This parameter is only applicable to transactions where TSB is the acquiring bank and the card is issued by TSB)",
      officePhoneNumber:
        "<b>Cardholder office phone number</b><br>Optional, length is limited to 15 characters. Verification must be combined with the cardholder's ID number. (This parameter is only applicable to transactions where TSB is the acquiring bank and the card is issued by TSB)",
      authenticateOnly:
        "<b>Identity authentication only flag</b><br>Y: Yes<br>(Only for identity authentication, amount must be 0)<br>N: No",
      cardholderInfo:
        "<b>Identity verification transaction information.</b><br>When “cardholderInfo” is not empty, at least one field of the cardholder information must have a value.",
      subMerchant: "<b>Sub-merchant information</b>",
      subMerid:
        "<b>Sub-merchant ID</b><br>The length of sub-merchant MCC and name will be verified if sub-merchant ID's length is 8",
      subMcc:
        "<b>Sub-merchant MCC</b><br>Sub-merchant category code.<br>The length is fixed at 4 when sub-merchant ID's length is 8",
      subMerName:
        "<b>Sub-merchant Name</b><br>Sub-merchant English short name.<br> When the sub-merchant ID length is 8 characters, the short name must not exceed 10 characters.",
      recurringPaymentSetting: "<b>Recurring payment setting</b>",
      periods: "<b>Payment period</b><br>Numbers only (0-9)",
      cycle: "<b>Payment cycle</b><br>Numbers only (0-9)",
      cycleType:
        "<b>Payment period type</b><br>D: Day W: Week M: Month Y: Year",
      recurringUpdateURL:
        "<b>Recurring payment result notification URL</b><br>If the transaction is a recurring payment and a recurring payment result callback URL is configured, the result will be sent in plain text to the specified URL via POST after the scheduled execution.",
      subsequentSetting: "<b>Recurring payment – next period settings</b>",
      phoneNumber:
        "<b>Phone number (For failed payment or final installment notifications)</b><br>To use this feature, an application must be submitted to HiTRUSTpay. The service will be activated once the relevant settings are completed. Additionally, enabling this feature will incur extra charges.",
      recurringStartDate:
        "<b>Next recurring payment date</b><br>Format: yyyy-MM-dd",
      recurringTransAmount:
        "<b>Next recurring payment amount</b><br>It must include two decimal digits. e.g. If the input amount is 100, it means the “amount” is 1 dollar.",
      recurringDepositFlag:
        "<b>Next recurring payment auto deposit flag</b><br>0 : Standard Transaction<br>1 : Sale Transaction(Auto deposit)",
      extensionField: "<b>Extend field</b>",
      threeDSExtraField: "<b>3DS authentication extra data</b>",
      enName:
        "<b>Cardholder English Name</b><br>Length limit: 2–45 characters. Only letters, spaces, and dash (-) are allowed. Either the cardholder's mobile phone number (including country code) or email address is required.",
      mobileCC:
        "<b>Cardholder Mobile Country Code</b><br>Length limit: 1–3 digits. Only numeric characters are allowed. Required when entering the cardholder's mobile phone number.<br>*If the field is empty, please put in an empty string.",
      mobilePhone:
        "<b>Cardholder Mobile Number</b><br>Length limit: 15 digits. Only numeric characters are allowed. Required when entering the cardholder's mobile country code.<br>*If the field value is empty, please provide an empty string.",
      cardholderEmail:
        "<b>Cardholder Email Address</b><br>Length limit: 254 characters.<br>*If the field value is empty, please provide an empty string.",
      cancelURL: "<b>Cancel URL</b>",
      eInvoice: "<b>E-Invoice Information</b>",
      invoiceEmail:
        "<b>E-Invoice email</b><br>The default delivery method can be set through email.",
      invoiceItem: "<b>E-Invoice item</b>",
      productionCode:
        "<b>E-Invoice item code</b><br>Length: 20 alphanumeric characters or 10 Chinese characters",
      description:
        "<b>E-Invoice item name</b><br>Length: 256 alphanumeric characters or 128 Chinese characters",
      quantity: "<b>E-Invoice item amount</b><br>Length: 17 digits",
      unit: "<b>E-Invoice item unit</b><br>Length: 6 alphanumeric characters or 3 Chinese characters",
      unitPrice: "<b>E-Invoice item price</b><br>Length: 17 Digits",
      retCode: "<b>Transaction result</b><br>Response Message List（retcode）",
      token:
        "<b>Payment page and communication tag</b><br>Payment page url and communication tag (For redirecting users to payment page)",
      transType:
        "<b>Transaction type</b><br>1: Authorization<br>3: Capture<br>4: Capture Reverse<br>5: Refund<br>6: Refund Reverse<br>7: Query<br>8: Authorization Reverse",
      transType_simple: "<b>Transaction type</b>",
      authCode: "<b>Authorization code</b>",
      authRRN: "<b>Authorization retrieval reference number</b>",
      panMask:
        "<b>Masked card number</b><br>To obtain the masked card number's first six and last four digits, apply to HiTRUSTPay to enable the setting.",
      riskDetectCode:
        "<b>Risk detection status</b><br>Returns a value when risk detection service is enabled.<br>Value: low, mid, high",
      riskActionStatus:
        "<b>Risk verification action status</b><br>Returns a value when risk detection service is enabled.<br>Value: low, mid, high<br>RMCA (Requires Manual Check Approval)<br>RMCR (Requires Manual Check Rejection)<br>REAP (Risk Evaluation Action Pending)<br>REAA (Risk Evaluation Action Approved)<br>REAR(Risk Evaluation Action Rejected)",
      merUpdateQueryDetail:
        "<b>Transaction result detail</b><br>(Has value when queryFlag=1)",
      orderStatus: "<b>Order status</b><br>#Order Status Code",
      eci: "<b>Authorization method</b><br>SSL,VISA3D",
      orderDate: "<b>Order date</b><br>YYYY-MM-DD-HH.MM.SS.XXXXXX",
      apOrderDate: "<b>Order date</b><br>YYYY-MM-DD",
      approveAmount: "<b>Approved amount</b>",
      captureAmount: "<b>Capture amount</b>",
      payBatchNum: "<b>Capture batch number</b>",
      captureDate: "<b>Capture date</b><br>YYYY-MM-DD-HH.MM.SS.XXXXXX",
      refundAmount: "<b>Refund amount</b>",
      refundBatch: "<b>Refund batch number</b>",
      refundRRN: "<b>Refund retrieval reference number</b>",
      refundCode: "<b>Refund authorization code</b>",
      refundDate: "<b>Refund date</b><br>YYYY-MM-DD-HH.MM.SS.XXXXXX",
      redemOrderNum: "<b>Redeem order number</b>",
      redemDiscountPoint: "<b>Redeemed discount point</b>",
      redemDiscountAmount: "<b>Redeemed discount amount</b>",
      redemPurchaseAmount: "<b>Amount paid</b>",
      redemBalancePoint: "<b>Remaining points</b>",
      firstPeriodAmount: "<b>First installment amount</b>",
      periodicAmount: "<b>Installment amount</b>",
      trxTokenInfo: "<b>Transaction token information</b>",
      trxToken: "<b>Transaction token</b>",
      ifShowTrxToken: "Has value when showTrxToken=true",
      reqTrxToken: "",
      cvv2_trx:
        "<b>CVC2/CVV2</b><br>Security code: If the merchant has applied to enable CVC2/CVV2 verification, this field must contain the last three digits of the card's security code.",
      bindingWithVerify:
        "<b>Whether to also verify phone number</b><br>Yes: 1<br>No: 0",
      bindingCardCardholderInfo:
        "<b>Phone number verification: cardholder information</b><br>When bindingWithVerify =1, at least one field of bindingCardCardholderInfo can not empty",
      idNumber_9:
        "<b>Cardholder's ID number</b><br>Start with an uppercase English letter, followed by 9 digits.",
      birthday: "<b>Cardholder's date of birthday</b><br>yyyyMMdd",
      cellPhoneNumber_10:
        "<b>Cardholder's phone number</b><br>Length is limited to 10 characters",
      lastBindCardTime:
        "<b>Transaction token create time</b><br>yyyy-MM-dd.HH.mm",
      paymentQueryResult:
        "<b>Transaction result detail</b><br>(Has value when queryFlag=1)",
      QueryPaymentQueryResult: "<b>Transaction result detail</b>",
      creditCardTransactionResult:
        "<b>Transaction result detail</b><br>Has value when queryFlag=1",
      QueryCreditCardTransactionResult:
        "<b>Transaction result detail</b><br>Has value when querying credit card transaction",
      TransactionCreditCardTransactionResult:
        "<b>Transaction result detail</b><br>Has value when querying credit card transaction and queryFlag=1",
      walletType:
        "<b>Mobile payment type enabled</b><br>1: Enable Applepay<br>2: Enable Google Pay<br>3: Enable Samsung Pay",
      mobileWalletPaymentData: "<b>Json data Apple/google returns</b>",
      encryptedByGW:
        "<b>Encryption flag</b><br>Y: Use HiTRUST's certificate<br>N: Not to use HiTRUST's certificate<br>Default value is “Y”, to use HiTRUST's certificate",
      tavv: "<b>TAVV</b><br>When walletType=1, please put in the decrypted TAVV value",
      eci_decrypted:
        "<b>ECI</b><br>When walletType=1, please put in the decrypted ECI value",
      afteeMerUserNo: "<b>AFTEE merchant user ID</b>",
      afteeCustomer: "<b>Customer information</b>",
      customer_name: "<b>Name</b><br>Less than 100 characters",
      phone_number:
        '<b>Phone number</b><br>A 10-digit numeric string starting with "09"',
      address: "<b>Address</b><br>Less than 255 characters",
      email: "<b>Email</b>",
      email225: "Less than 255 characters with correct email format",
      additional_info_code:
        "<b>Additional information code</b><br>Please put empty String",
      user_registration_date:
        "<b>Merchant registration date</b><br>Format: YYYY-MM-DD",
      afteeDestCustomers: "<b>Receiver information</b>",
      dest_customer_name: "<b>Receiver name</b><br>Less than 100 characters",
      dest_address:
        "<b>Receiver address</b><br>Less than 255 characters not including spaces",
      dest_tel:
        '<b>Receiver number</b><br>A 9~10 digit numeric string starting with "0". Telephone must have area code',
      afteeItems: "<b>Item information</b>",
      jPayCustomer: "<b>Customer information</b>",
      pay_firstname: "<b>Bill first name</b>",
      pay_lastname: "<b>Bill last name</b>",
      pay_street_address1: "<b>Bill address 1</b>",
      pay_street_address2: "<b>Bill address 2</b>",
      pay_city: "<b>Bill city</b>",
      pay_postcode: "<b>Bill postal code</b>",
      pay_state: "<b>Bill state</b>",
      pay_country_iso_code_2: "<b>Bill country code</b>",
      pay_email_address: "<b>Bill email address</b>",
      pay_telephone: "<b>Bill telephone</b>",
      jPayDestCustomer: "<b>Receiver information</b>",
      shipping_firstname: "<b>Receiver first name</b>",
      shipping_lastname: "<b>Receiver last name</b>",
      shipping_street_address1: "<b>Receiver address 1</b>",
      shipping_street_address2: "<b>Receiver address 2</b>",
      shipping_city: "<b>Receiver city</b>",
      shipping_postcode: "<b>Receiver postal code</b>",
      shipping_state: "<b>Receiver state</b>",
      shipping_country_iso_code_2: "<b>Receiver country</b>",
      shipping_email_address: "<b>Receiver email address</b>",
      shipping_telephone: "<b>Receiver telephone</b>",
      jPayItems: "<b>Item information</b>",
      sku: "<b>Item No. (unique)</b>",
      productName: "<b>Item name</b>",
      productImage: "<b>Item image</b>",
      attributes: "<b>Item attribute</b>",
      price: "<b>Item price</b>",
      quantity: "<b>Item quantity</b>",
      shop_item_id:
        "<b>Item ID</b><br>Length: 100 alphanumeric characters not including spaces",
      item_name:
        "<b>Item name</b><br>Length: less than 100 characters not including spaces",
      item_category:
        "<b>Item category</b><br>Length: less than 100 characters not including spaces. Please put in an empty string if there is no value",
      item_price:
        "<b>Item price</b><br>A number that is 0 or up to 6 digits long; leading zeros and negative values are not allowed.",
      item_count:
        "<b>Item count</b><br>A number that is 1 or up to 5 digits long; leading zeros are not allowed.",
      item_url:
        "<b>Item URL</b><br>Length: less than 1000 characters. Please put in an empty string if there is no value",
      discount: "<b>Transaction discount</b>",
      interactionInfo: "<b>Interaction fields</b>",
      interactionType:
        "<b>Type</b><br>M: Field value is mandatory<br>O: Field value is optional",
      fieldName:
        "<b>Field name</b><br>Length: 1-30 bytes. No commas or separators allowed. Leave blank if there is no value.",
      fieldValue:
        "<b>Field value</b><br>Length: 1 to 30 bytes. It can be a default value or entered by the customer. No commas or separators allowed. Leave blank if there is no value.",
      editable: "<b>Editable</b><br>Y: can be edited<br>N: Can not be edited",
      cfcBuyerInfo:
        "<b>Zingala member information</b><br>2 purposes:<br>Only assigned buyer can checkout (prevent transaction denial). Increase verification success rate.",
      specific_id: "<b>Member ID number</b>",
      shipping_address: "<b>Shipping address</b>",
      account_age:
        "<b>Account age</b><br>The account registration date to this date:<br>false: less than 30 days<br>true: 30 days or more.",
      last_order_date: "<b>Previous order date</b><br>Format: yyyy-mm-dd",
      last_order_amount: "<b>Previous order amount</b>",
      cfcValidDays:
        "<b>Zingala payment valid day</b><br>payment_url valid day. The minimum is 1 day (same day), the maximum is 30 days, with a default of 7 days.",
      cfcInstallmentPeriod:
        "<b>Installment period</b><br>Ex 1: Full payment, 3: 3 installment periods",
      jkoRedeemAmount:
        "<b>Total discount amount</b><br>(Has value when queryFlag=1)",
      jkoRedeemJkoCoinamount:
        "<b>Jko coin amount</b><br>(Has value when queryFlag=1)",
      jkoRedeemOfficialCouponAmount:
        "<b>Official jko coupon redeemed amount</b><br>(Has value when queryFlag=1)",
      jkoRedeemStoreCouponAmount:
        "<b>Store jko coupon redeemed amount</b><br>(Has value when queryFlag=1)",
      jkoDebitAmount:
        "<b>Discounted amount</b><br>(Has value when queryFlag=1)",
      jkoChannelType:
        "<b>Payment type</b><br>account: Stored value account<br>bank: Bank account<br>creditcard: Credit card<br>(Has value when queryFlag=1)",
      showTrxToken: "<b>Whether to return trxToken</b>",
      trxStatusCode:
        "<b>Transaction status</b><br>Has value when showTrxToken=true",
      payWay:
        "<b>Payment type</b><br>1 : Apple Pay<br>2 : Google Pay(Wallet Mode)<br>3 : Samsung Pay<br>4 : Google Pay(Account Mode)<br>5 : LINE Pay<br>6 : Authorization with TrxToken<br>other : Normal",
      linePayRtnCode: "<b>LINEPAY return code</b><br>LINEPAY transaction only",
      linePayTransId:
        "<b>LINEPAY transaction ID</b><br>LINEPAY transaction only",
      virtualAccountInfo: "<b>虛擬帳號資訊</b>",
      bankCode: "<b>銀行代碼</b>",
      virtualAccount: "<b>Virtual account</b>",
      expireDate: "<b>繳費期限</b>",
      cvsInfo: "<b>超商代收資訊</b>",
      paymentNo: "<b>繳費代碼</b>",
      apName: "<b>Customer name</b><br>Length: less than 50 characters",
      apEmail: "<b>Customer email </b><br>Length: less than 50 characters",
      cvsName: "<b>Name</b><br>Length: less than 50 characters",
      cvsEmail: "<b>EMAIL</b><br>Length: less than 50 characters",
      payDueDate: "<b>Payment due date</b><br>yyyyMMdd",
      transDate: "<b>Payment date</b><br>YYYYMMDD",
      csvPayDate: "<b>Payment date</b><br>YYYY-MM-DD-HH.MM.SS.XXXXXX",
      csvChargeOffDate: "<b>Reconciled date</b><br>YYYY-MM-DD-HH.MM.SS.XXXXXX",
      apDate: "<b>Reconciled date</b><br>YYYY-MM-DD",
      orderStatus_va_settlement:
        "<b>Order status</b><br>10: Not reconciled (For non-SPB acquirer bank merchants)<br>11: Reconciled<br>12: Not fully paid<br>14: Overpayment<br>16: Not reconciled (For SPB acquirer bank merchants)",
      orderStatus_spb_va_settlement:
        "<b>Order status</b><br>10: Not reconciled (For non-SPB acquirer bank merchants)<br>11: Reconciled<br>12: Not fully paid<br>14: Overpayment<br>16: Not reconciled (For SPB acquirer bank merchants)<br>20: Refund in process (SPB)<br>21: Refund failed (SPB)<br>22: Refunded (SPB)<br>23: Invalid (SPB)",
      orderStatus_cvs_settlement:
        "<b>Order status</b><br>20 : Unsettled<br>21 : Settled",
      barcode1: "<b>Barcode1</b>",
      barcode2: "<b>Barcode2</b>",
      barcode3: "<b>Barcode3</b>",
      orderAmount:
        "<b>Transaction amount</b><br>Divided by 100 to get the actual amount",
      transAmount:
        "<b>Reconciled amount</b><br>Divided by 100 to get the actual amount",
      emailAddress:
        "<b>Payer email</b><br>Separate with “,” if there are multiple emails",
      orderName: "<b>Order name</b>",
      orderNameLimit: "Length: Less than 10 Chinese  or 20 English characters",
      availableStartDate: "<b>Payment valid start date</b><br>yyyy/MM/dd",
      availableEndDate: "<b>Payment valid end date</b><br>yyyy/MM/dd",
      installmentPlans:
        "<b>Installment period</b><br>Please separate with “,”, Example: if 3 and 6 periods are available the value is 0,3,6",
      noticeMail: "<b>Payment completion notification email</b>",
      easyPayLink:
        "<b>Payment link</b><br>Append the token value from easyPayOrderDetails to get the actual payment link",
      easyPayOrderDetails: "<b>Easypay order detail</b>",
      easyPayUpdateURL: "<b>Payment completion updateURL</b>",
      mail: "<b>Payer Email</b>",
      orderId: "<b>Order ID</b>",
      easypayQueryEmail:
        "<b>Payer Email </b><br>Can only search 1 email(At least one search parameter is not empty)",
      availableStartDateQuery:
        "<b>Payment valid start date</b><br>Format: yyyy/MM/dd(At least one search parameter is not empty)",
      availableEndDateQuery:
        "<b>Payment valid end date</b><br>Format: yyyy/MM/dd(At least one search parameter is not empty)",
      createStartDate:
        "<b>Creation start date</b><br>Format: yyyy/MM/dd(At least one search parameter is not empty)",
      createEndDate:
        "<b>Creation end date</b><br>Format: yyyy/MM/dd(At least one search parameter is not empty)",
      easyPayOrderId:
        "<b>Easypay order ID</b><br>(At least one search parameter is not empty)",
      queryMaskPan:
        "<b>Whether to return masked card number</b><br>0:No<br>1:Yes",
      startDate: "<b>Payment start date</b><br>yyyyMMddHHmmss",
      endDate: "<b>Payment end date</b><br>yyyyMMddHHmmss",
      createDate: "<b>Payment creation date</b><br>yyyyMMddHHmmss",
      easypayStatus:
        "<b>Order status</b><br>0:Not paid 1:Payment processing 2:Paid 5:Payment paused",
      payDate: "<b>Payment date</b>",
      installmPlan: "<b>Available installment period</b>",
      paytype:
        "<b>Payment type</b><br>1: Sale Transaction(Auto deposit)<br>0: Standard Transaction",
      maskPan: "<b>Masked credit card</b><br>",
      maskPanDesc: "Has value only when queryMaskPan=1 and status=2",
      easypayUpdateToken: "<b>Token</b>",
      easypayUpdateEmail: "<b>Payer Email</b>",
      changeStatusTo:
        "<b>Change status to </b><br>0:Not paid<br>5:Payment pause",
      periodOrderNumber: "<b>Current period failed order number</b>",
      recurringPaymentData: "<b>Recurring payment data</b>",
      recurringPaymentInfo: "<b>Recurring payment information</b>",
      createTime: "<b>Order creation time</b><br>YYYY-MM-DD-HH.MM.SS",
      periodType: "<b>Period type</b><br>Y-Year , M-Month , D-Day",
      deductFreq: "<b>Recurring payment frequency</b>",
      deductTotalNum: "<b>Recurring payment total period</b>",
      deductChargedNum: "<b>Number of recurring payment periods paid</b>",
      recurringPaymentDetails: "<b>Recurring payment detail</b>",
      periodNumber: "<b>Period number</b>",
      recurringStatus:
        "<b>Status</b><br>00 Payment made<br>01 Payment pending<br>02 Payment failed<br>03 Payment terminated",
      estimatedDeductDate: "<b>Next payment date</b>",
      trxStatus:
        "<b>Failed transaction return code</b><br>Has value when transaction failed",
      approvable:
        "<b>Whether approval can Be granted</b><br>true: yes<br>false:no",
      riskDetectCode_request:
        "<b>Risk detection code</b><br>Obtained from orders awaiting approval",
      operatorId: "<b>operatorId</b>",
      connectorId: "<b>Connector ID</b>",
      instituteId: "<b>Institution ID</b>",
      mac: "<b>Signature value of merchant key</b>",
      timestamp: "<b>Timestamp</b>",
      veriIdTransID: "<b>VeriId transaction ID</b>",
      merTransID: "<b>Merchant transaction ID</b>",
      version: "<b>API version</b>",
      html: "<b>Payment page and communication tag</b><br>Payment page url and communication tag (For redirecting users to payment page)",
    },
  },
};
